var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#EDEDF3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.9354 30.7742C29.5032 30.7742 30.7741 29.5033 30.7741 27.9355C30.7741 26.3677 29.5032 25.0968 27.9354 25.0968C26.3676 25.0968 25.0967 26.3677 25.0967 27.9355C25.0967 29.5033 26.3676 30.7742 27.9354 30.7742Z",
    fill: "#B5B7C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 16C21.3726 16 16 21.3726 16 28C16 31.9432 17.9021 35.4421 20.8387 37.6295V27.9355C20.8387 24.016 24.016 20.8387 27.9355 20.8387C30.8453 20.8387 33.3448 22.5907 34.4401 25.0968H39.6456C38.3473 19.8722 33.6262 16 28 16Z",
    fill: "#B5B7C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7956 31.9356C32.5178 33.8048 30.3706 35.0323 27.9354 35.0323C26.9258 35.0323 25.9662 34.8202 25.0967 34.4401V39.6457C26.0264 39.8767 26.9987 40.0001 27.9999 40.0001C32.2018 40.0001 35.8958 37.8384 38.0386 34.5682L33.7956 31.9356Z",
    fill: "#B5B7C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.44 25.0968H32.0645V30.7742H34.44H34.789L39.6455 25.0968H34.44Z",
    fill: "#B5B7C6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.6456,
    height: 24,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.a0eaaf7a7876dd15f6601a4b3cd5ac7d.svg";
export { ForwardRef as ReactComponent };